var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSummaryBirthday(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.12609 7.34741V7.9701C1.12609 8.70416 1.0659 8.96854 1.95972 8.96854H6.97159C7.86484 8.96854 7.80409 8.7036 7.80409 7.9701V7.34741H1.12609Z",
    fill: "#434343",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77594 1.6875H2.25V3.4155H2.77594V1.6875Z",
    fill: "#434343",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1.6875H3.9375V3.35756H4.5V1.6875Z",
    fill: "#434343",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74437 1.6875H6.1875V3.29119H6.74437V1.6875Z",
    fill: "#434343",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.79289 0.54844C2.84914 0.776815 2.76026 1.0395 2.54707 1.06313C2.34795 1.08563 2.19551 0.828565 2.34851 0.573752C2.50545 0.315002 2.54707 0.0337524 2.54707 0.0337524C2.54707 0.0337524 2.72707 0.27394 2.79289 0.54844Z",
    fill: "#434343",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46524 0.574328C4.5243 0.813953 4.43093 1.0907 4.20142 1.11545C3.98711 1.13908 3.82343 0.868516 3.9888 0.601328C4.15755 0.328516 4.20142 0.0332031 4.20142 0.0332031C4.20142 0.0332031 4.3938 0.286328 4.46524 0.574328Z",
    fill: "#434343",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73543 0.575475C6.79843 0.8151 6.69831 1.09072 6.45531 1.11547C6.22806 1.1391 6.05368 0.869099 6.22974 0.601912C6.40918 0.330225 6.45531 0.0349121 6.45531 0.0349121C6.45531 0.0349121 6.65949 0.288037 6.73543 0.575475Z",
    fill: "#434343",
    fillOpacity: 0.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76964 4.74584C2.00308 4.74584 2.34114 4.52422 2.44071 4.44659C2.44352 4.44322 2.84964 4.06184 3.34183 4.06184C3.83177 4.06184 4.25477 4.43984 4.27221 4.45616C4.36333 4.53491 4.66483 4.74584 4.93258 4.74584C5.24871 4.74584 5.55583 4.46178 5.55583 4.46178C5.57833 4.44041 5.99852 4.06184 6.50533 4.06184C7.01439 4.06184 7.41996 4.44322 7.43683 4.45953C7.52739 4.53716 7.69783 4.65134 7.85139 4.70816C7.83396 3.97634 7.49758 3.39191 6.62739 3.39191H2.39571C1.61327 3.39191 1.26058 3.86272 1.18408 4.48822C1.31064 4.58216 1.57108 4.74584 1.76964 4.74584Z",
    fill: "#434343",
    fillOpacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15321 5.32636C7.14309 5.31736 6.8399 5.03442 6.50577 5.03442C6.16884 5.03442 5.85046 5.31961 5.84653 5.32299C5.8319 5.33592 5.42409 5.71674 4.93302 5.71674C4.44646 5.71674 4.00996 5.34155 3.9914 5.32524C3.89971 5.24311 3.60778 5.03442 3.34228 5.03442C3.02615 5.03442 2.72128 5.31736 2.71734 5.31961C2.65265 5.37136 2.19309 5.71674 1.77009 5.71674C1.55296 5.71674 1.33584 5.6273 1.16821 5.53392V6.71911H7.85577V5.69874C7.51209 5.6273 7.19371 5.36067 7.15321 5.32636Z",
    fill: "#434343",
    fillOpacity: 0.8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91619 7.875H0V8.96344H8.91619V7.875Z",
    fill: "#434343",
    fillOpacity: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryBirthday);
export default __webpack_public_path__ + "static/media/Summary-Birthday.3b0a0892c7a56f168680aee8ae544e22.svg";
export { ForwardRef as ReactComponent };